/**
 * 微信扫码
 */

import wx from 'weixin-js-sdk';

export default {
  name:"",
  data(){
    return{
      scanResult:'',
      wxPlatformParam:{
          noncestr:'',
          signature:'',
          timestamp:0,
          appId:''
      },
      loadingObj:{
          showLoading:false,
          loadingText:'加载中...',
      }
    }
  },
  methods:{
    wxPenSign(signWebUrl,isHideMenu){
      this.loadingObj.loadingText = '检测使用环境中...';
      this.loadingObj.showLoading = true;
      //校验信息
      let formdata = {
          service: 'user.penSign',
      };
      var _this = this;
      formdata.webUrl = signWebUrl;      
      this.$api.post("/mstx/pr/gateway.do", formdata, (res) => {
          this.loadingObj.showLoading = false;
          this.wxPlatformParam.appId = res.appId;
          this.wxPlatformParam.timestamp = res.timestamp;
          this.wxPlatformParam.noncestr = res.noncestr;
          this.wxPlatformParam.signature = res.signature;
          wx.config({
              appId: _this.wxPlatformParam.appId,
              timestamp: _this.wxPlatformParam.timestamp,
              nonceStr: _this.wxPlatformParam.noncestr,
              signature: _this.wxPlatformParam.signature,
              jsApiList: ['scanQRCode',
              'hideMenuItems'] 
          });
          wx.ready(function(){
               //禁用链接传播
               if(isHideMenu){
                 wx.hideOptionMenu();
                //   wx.hideMenuItems({
                //     menuList: [
                //       'menuItem:editTag',
                //       'menuItem:delete',
                //       'menuItem:copyUrl',
                //       'menuItem:originPage',
                //       'menuItem:readMode',
                //       'menuItem:openWithQQBrowser',
                //       'menuItem:openWithSafari',
                //       'menuItem:share:email',
                //       'menuItem:share:brand',
                //       'menuItem:share:appMessage',
                //       'menuItem:share:timeline',
                //       'menuItem:share:qq',
                //       'menuItem:share:weiboApp',
                //       'menuItem:favorite',
                //       'menuItem:share:facebook',
                //       'menuItem:share:QZone'],
                //     success:function(){
                //     }
                // });
              }
          });
      },()=>{
          this.loadingObj.showLoading = false;
          this.$toast.fail("获取扫码权限失败,可刷新页面重新检测...");
      });
     
    },
    wxScanBar(){
      var _this = this;
      wx.ready(function(){
          wx.scanQRCode({
              needResult: 1,
              scanType:['barCode'],
              success: function(res) {
                  //扫码后获取结果参数赋值给Input
                  var url = res.resultStr;
                  //商品条形码，取","后面的
                  if (url.indexOf(",") >= 0) {
                      var tempArray = url.split(',');
                      _this.scanResult = tempArray[1];
                  } else {
                    this.$toast.fail("请对准条形码扫码...");
                  }
              },
              fail:function () {
                  this.$toast.fail("扫码失败...");
              }
          });
      });
    }
  }
}
